import { Link } from 'react-router-dom';
import { ShieldCheck, Zap, Lock, Star } from 'lucide-react';
import { useSectionTranslation } from '@/hooks';
import { authBrandTranslations } from './translations';

/** Branded left panel shown on auth pages (hidden on mobile). */
export function AuthBrandPanel() {
  const t = useSectionTranslation(authBrandTranslations);
  const features = [
    { icon: ShieldCheck, title: t.brand.features[0].title, text: t.brand.features[0].text },
    { icon: Zap, title: t.brand.features[1].title, text: t.brand.features[1].text },
    { icon: Lock, title: t.brand.features[2].title, text: t.brand.features[2].text },
  ];

  return (
    <div className="relative hidden lg:flex flex-col justify-between p-10 xl:p-14 overflow-hidden bg-surface-card">

      <div className="relative z-10">
        <Link to="/" className="flex items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-surface-hover border border-surface-border text-accent">
            <ShieldCheck size={20} />
          </div>
          <span className="font-display text-3xl text-brand-white">Playerso</span>
        </Link>
      </div>

      <div className="relative z-10 max-w-md">
        <h2 className="font-display text-display-lg text-brand-white mb-4 leading-[1.05]">
          {t.brand.headlineA} <span className="text-accent-gradient">{t.brand.headlineB}</span>
        </h2>
        <p className="text-body-md text-brand-muted mb-10">{t.brand.subtext}</p>

        <ul className="space-y-5">
          {features.map((f) => (
            <li key={f.title} className="flex items-start gap-3">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-hover border border-surface-border text-accent">
                <f.icon size={16} />
              </div>
              <div>
                <p className="text-sm font-semibold text-brand-white">{f.title}</p>
                <p className="text-xs text-brand-muted">{f.text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="relative z-10 flex items-center gap-2 text-xs text-brand-muted">
        <Star size={12} className="text-accent" />
        {t.brand.rating}
      </div>
    </div>
  );
}